"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonImage = SkeletonImage;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["testId", "offsetLeft", "offsetTop", "width", "height", "radiusX", "radiusY"];

function SkeletonImage(_ref) {
  var _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'cf-ui-skeleton-image' : _ref$testId,
      offsetLeft = _ref.offsetLeft,
      offsetTop = _ref.offsetTop,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 70 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 70 : _ref$height,
      _ref$radiusX = _ref.radiusX,
      radiusX = _ref$radiusX === void 0 ? 0 : _ref$radiusX,
      _ref$radiusY = _ref.radiusY,
      radiusY = _ref$radiusY === void 0 ? 0 : _ref$radiusY,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("rect", (0, _extends2["default"])({
    x: offsetLeft,
    y: offsetTop,
    rx: radiusX,
    ry: radiusY,
    width: width,
    height: height,
    "data-test-id": testId
  }, otherProps));
}